/* eslint-disable jsx-a11y/anchor-is-valid */
import { Col, Row } from "react-bootstrap";

import React from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";

// import { NewButton } from '../../elements/ActionButtons/NewButton.jsx';

function MainContentHeader({
  name,
  backUrl,
  xs,
  sm,
  md,
  lg,
  intl,
  history,
  children,
  hasBtn = false
}) {
  let title = name ? (
    <h1 className="navbar-brand">
      {backUrl && <i className="fa fa-angle-left" />}
      {intl.formatMessage({ id: name })}
    </h1>
  ) : (
    ""
  );

  return (
    <div
      className={hasBtn === false ? "main-header" : "main-header-with-button"}>
      <Row>
        <Col xs={xs} sm={sm} md={md} lg={lg} className="navbar">
          {backUrl ? (
            <a to="" onClick={() => history.goBack()}>
              {title}
            </a>
          ) : (
            title
          )}
          {children}
        </Col>
      </Row>
    </div>
  );
}

export default withRouter(injectIntl(MainContentHeader));
